module.exports = __webpack_public_path__ + "static/media/gear-sm.140ffe73.svg";